export enum RoleEnum {
  SUPER_ADMIN = 'Super Administrator',
  DISTRICT = 'District',
  TEACHER = 'Teacher',
  STUDENT = 'Student',
  NULL_USER = '',
}

export interface IRoleDTO {
  id: number;
  roleName: RoleEnum;
}

export class RoleDTO implements IRoleDTO {
  id: number = 0;
  roleName: RoleEnum = RoleEnum.NULL_USER;

  static isValidRoleType(role: RoleEnum): role is RoleEnum {
    return [
      RoleEnum.DISTRICT,
      RoleEnum.TEACHER,
      RoleEnum.STUDENT,
      RoleEnum.SUPER_ADMIN,
    ].includes(role);
  }

  /**
   * Checks if the parameter matches the `Super Administrator`, `District`, or `Teacher` roles.
   */
  static canEdit(role: RoleEnum): role is RoleEnum {
    return [RoleEnum.DISTRICT, RoleEnum.TEACHER, RoleEnum.SUPER_ADMIN].includes(
      role,
    );
  }

  /**
   * Checks if the parameter matches the `Super Administrator` or `District` roles.
   */
  static isAdminRoleType(role: RoleEnum): role is RoleEnum {
    return [RoleEnum.DISTRICT, RoleEnum.SUPER_ADMIN].includes(role);
  }

  /**
   * Checks if the parameter matches the `Student` role.
   */
  static isStudentRoleType(role: RoleEnum): role is RoleEnum {
    return [RoleEnum.STUDENT].includes(role);
  }

  /**
   * Checks if the parameter matches the `Super Administrator` role.
   */
  static isSuperAdminRoleType(role: RoleEnum): role is RoleEnum {
    return [RoleEnum.SUPER_ADMIN].includes(role);
  }

  /**
   * Checks if the parameter matches the `Teacher` role.
   */
  static isTeacher(role: RoleEnum): role is RoleEnum {
    return role === RoleEnum.TEACHER;
  }

  constructor(configOverride?: Partial<IRoleDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IPermissionCheck {
  canEdit: boolean;
  hasAcceptedStudentAgreements: boolean;
  hasAcceptedTeacherAgreement: boolean;
  isAdmin: boolean;
  isEnrolled: boolean;
  isLocalUser: boolean;
  isStudent: boolean;
  isSuperAdmin: boolean;
  isTeacher: boolean;
  isValid: boolean;
}

export class PermissionCheck implements IPermissionCheck {
  canEdit: boolean = false;
  hasAcceptedStudentAgreements: boolean = false;
  hasAcceptedTeacherAgreement: boolean = false;
  isAdmin: boolean = false;
  isEnrolled: boolean = false;
  isLocalUser: boolean = false;
  isStudent: boolean = false;
  isSuperAdmin: boolean = false;
  isTeacher: boolean = false;
  isValid: boolean = false;

  constructor(configOverride?: Partial<IPermissionCheck>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
